import { useHistory } from "react-router-dom";

export function SemifinalAdmin() {
    let history = useHistory();
    window.open("https://semifinal.impactitb.com/admin", "/");
    history.go(-1);
    return null;
  };